import { Dialog, DialogContent, DialogTitle, LinearProgress, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

const BlockAndSectionLoading: FC = () => {
  const editingClusterOrSection = useAppSelector((state) => state.blocks.editingClusterOrSection);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (editingClusterOrSection) {
      setIsOpen(true);
    }
  }, [editingClusterOrSection]);

  useEffect(() => {
    if (!editingClusterOrSection && isOpen) {
      setTimeout(() => {
        setIsOpen(false);
      }, 1500);
    }
  }, [editingClusterOrSection, isOpen]);

  return (
    <Dialog open={isOpen}>
      <DialogTitle>Even geduld</DialogTitle>
      <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <Typography>Je wijzigingen worden bewaard.</Typography>
        <LinearProgress />
      </DialogContent>
    </Dialog>
  );
};

export default BlockAndSectionLoading;
